<ng-container *ngIf="form">
  <form [formGroup]="form">
    <sidenav-content-header [title]="isCreatingNewInjector ? 'Crea Injector' :'Dettaglio Injector '+ injector!.id"
      (close)="onCloseClick()">

      <span *ngIf="!isCreatingNewInjector" buttonInfo style="cursor: pointer;"
        title="visualizza info ricevute"><label>Creato</label>
      {{injector!.created |  formatDateWithTimezone | async}}
      </span>

      <span *ngIf="!isCreatingNewInjector" buttonInfo><label>ultima modifica</label>
      {{injector!.updated |  formatDateWithTimezone | async}}
      </span>

    </sidenav-content-header>

    <div class="leadInjectorContainer">

      <div class="leadInformationWrapper">
        <!-- Details -->
        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title>Dettagli</mat-panel-title>
          </mat-expansion-panel-header>

          <mat-form-field appearance="outline">
            <mat-label>Descrizione</mat-label>
            <input validatorColor name="descrizione" matInput type="text" [formControl]="form!.controls.description" [disabled]="true"
              spellcheck="false" autocomplete="false">
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Note</mat-label>
            <input validatorColor name="note" matInput type="text" [formControl]="form!.controls.note" [disabled]="true"
              spellcheck="false" autocomplete="false">
          </mat-form-field>

          <div style="margin-bottom: 1rem;">
            <mat-slide-toggle [formControl]="form!.controls.isEnabled">Abilitato</mat-slide-toggle>
          </div>

          <div style="margin-bottom: 1rem;">
            <mat-slide-toggle [formControl]="form!.controls.isAutoOffer">Auto Offer</mat-slide-toggle>
          </div>

          <div class="activationPeriodWrapping">
            <div class="activationBeginItem">
              <app-calendar-picker [label]="'Inizio'" [form]="form!.controls.activationBegin">
              </app-calendar-picker>
              <time-input [defaultTime]=timeBegin (onUpdateTime)="onTimeBeginChange($event)"></time-input>
            </div>
            <div class="activationEndItem">

              <ng-container
                *ngIf="!((form!.controls.activationEnd?.value | isInfiniteDate) || !!!form!.controls.activationEnd?.value); else setEndDate">
                <app-calendar-picker [label]="'Fine'" [form]="form!.controls.activationEnd">
                </app-calendar-picker>
                <time-input [defaultTime]=timeEnd (onUpdateTime)="onTimeEndChange($event)"></time-input>
              </ng-container>

              <ng-template #setEndDate>
                <p class="setEndDateBtn" (click)="onSetEndDateClick()">Imposta fine</p>

              </ng-template>


            </div>
          </div>

        </mat-expansion-panel>

        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title>Domini autorizzati</mat-panel-title>
          </mat-expansion-panel-header>

          <ng-container formArrayName="domains" >
            <p>{{'dashboard.leadInjector.domainList.description' | translate}}</p>
            <div *ngFor="let domain of domains?.controls; let i = index" >
              <div [formGroupName]="i">
                <mat-form-field appearance="outline">
                  <mat-label>Dominio {{ i + 1 }}</mat-label>
                    <mat-icon matSuffix type="button" (click)="removeElementFromFormArray(domains, i)">delete</mat-icon>
                    <input formControlName="domain" matInput type="text">
                    <mat-error *ngIf="domain.get('domain')?.hasError('invalidDomain') && (domain.get('domain')?.dirty || domain.get('domain')?.touched)">
                      Inserisci un dominio valido
                    </mat-error> 
                </mat-form-field>
              </div>
            </div>
            <button mat-stroked-button type="button" (click)="addElementToFormArray(domains, 'domain', validDomainValidator())">+ Aggiungi Dominio</button>
          </ng-container>

        </mat-expansion-panel>

        <mat-expansion-panel expanded="true">
          <mat-expansion-panel-header>
            <mat-panel-title>IP autorizzati</mat-panel-title>
          </mat-expansion-panel-header>

          <ng-container formArrayName="ipAddresses" >
            <p>{{'dashboard.leadInjector.ipList.description' | translate}}</p>
            <div class="fields" *ngFor="let ip of ipAddresses?.controls; let i = index" >
              <div class="ipInput" [formGroupName]="i">
                <mat-form-field appearance="outline">
                  <mat-label>IP {{ i + 1 }}</mat-label>
                  <mat-icon matSuffix type="button" (click)="removeElementFromFormArray(ipAddresses, i)">delete</mat-icon>
                  <input formControlName="ip" matInput type="text">
                  <mat-error *ngIf="ip.get('ip')?.hasError('invalidIP') && (ip.get('ip')?.dirty || ip.get('ip')?.touched)">
                    Inserisci un IP valido
                  </mat-error>
                </mat-form-field>
              </div>        
            </div>
          <button mat-stroked-button type="button" (click)="addElementToFormArray(ipAddresses, 'ip', validIPValidator())">+ Aggiungi IP</button>
          </ng-container>
        </mat-expansion-panel>

        <!-- ng if true se sono in edit e false se sono in create -->
        <ng-container *ngIf="!isCreatingNewInjector">

          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title>Info</mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <p class="labelText">
                public key
              </p>
              <p class="injectorInfo">{{injector?.publicKey}}</p>
            </div>
            <div>
              <p class="labelText">
                external id
              </p>
              <p class="injectorInfo">{{injector?.externalId}}</p>
            </div>
            <div>
              <p class="labelText">
                url
              </p>
              <p class="injectorInfo">{{injector?.injectionEndpoint}}</p>
            </div>
          </mat-expansion-panel>



          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title>Developer</mat-panel-title>
            </mat-expansion-panel-header>

            <mat-form-field appearance="fill">
              <mat-label>encoding</mat-label>
              <mat-select [(value)]="htmlSnippedEncoding">
                <mat-option value="multipart/form-data">multipart/form-data</mat-option>
                <mat-option value="application/x-www-form-urlencoded">application/x-www-form-urlencoded
                </mat-option>
              </mat-select>
            </mat-form-field>

            <div class="textareaWrapper">
              <div class="textareaCopyButton" [cdkCopyToClipboard]="htmlSnipped.value"
                (cdkCopyToClipboardCopied)="onClipboardCopy($event)" data-cy="copyHTMLToClipboard">
                <button mat-mini-fab>
                  <mat-icon>content_copy</mat-icon>
                </button>
              </div>
              <mat-form-field appearance="fill">
                <mat-label>HTML</mat-label>
                <textarea   style="resize:none" matInput #htmlSnipped appInjectorHtmlSnipped [injector]="injector!"
                validatorColor [formControl]="form!.controls.htmlSnipped"
                  [encoding]="htmlSnippedEncoding" cols="30" rows="10" data-cy="HTMLtextarea"></textarea>
              </mat-form-field>
              <!--  -->
            </div>
            <div class="textareaWrapper">
              <div class="textareaCopyButton" [cdkCopyToClipboard]="curlSnipped.value"
                (cdkCopyToClipboardCopied)="onClipboardCopy($event)" data-cy="copyCURLToClipboard">
                <button mat-mini-fab>
                  <mat-icon>content_copy</mat-icon>
                </button>
              </div>
              <mat-form-field appearance="fill">
                <mat-label>JSON Curl</mat-label>
                <textarea  style="resize:none" matInput #curlSnipped validatorColor  [formControl]="form!.controls.curlSnipped" appInjectorCurlSnipped [injector]="injector!"
                  cols="30" rows="10" data-cy="CURLtextarea"></textarea>
              </mat-form-field>
            </div>
          </mat-expansion-panel>

        </ng-container>


        <ng-container *ngIf="injectorFacebookFormConfigurations.length">

          <mat-expansion-panel expanded="true">
            <mat-expansion-panel-header>
              <mat-panel-title>Facebook forms</mat-panel-title>
            </mat-expansion-panel-header>

            <div *ngFor="let form of injectorFacebookFormConfigurations">
              <span>{{form | json}}</span>
              <button name="salva" color="warn" mat-flat-button (click)="onGoSocialForm(form)">Go social form</button>
            </div>

          </mat-expansion-panel>

        </ng-container>

      </div>




      <div class="actionContainer">
        <div class="detail-row">
          <div class="right">
            <button (click)="onCancelClick()" mat-stroked-button type="button">Annulla</button>
            <button name="salva" [disabled]="!form!.dirty || form.invalid" color="warn" mat-flat-button
              (click)="onSaveClick()">Salva</button>
          </div>
        </div>
      </div>


    </div>

  </form>
</ng-container>